
<main-form-modal (toggleChange)="setVal($event)">
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">

            <ivrDonationDetail-edit *ngSwitchCase="true"></ivrDonationDetail-edit>
            <ivrDonationDetail-details *ngSwitchCase="false"></ivrDonationDetail-details>
        </div>
    </ng-template>
</main-form-modal>
